import Axios from 'axios';

const RESET_PASSWORD_EXPIRED_PATH = '/account/reset-password-expired';

Axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('reset-token') || localStorage.getItem('token');
  if (token) config.headers.Authorization = 'Token ' + token;
  return config;
});

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (error.config?.resetPasswordFlow && !error.config?.skipAuthRedirect) {
        localStorage.removeItem('reset-token');
        window.location.href = RESET_PASSWORD_EXPIRED_PATH;
      } else if (!error.config?.skipAuthRedirect) {
        localStorage.clear();
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export class Api {
  static async get(url, params = {}, option = {}) {
    return Axios.get(url, {
      ...option,
      params,
    });
  }

  static async post(url, body, option = {}) {
    return Axios.post(url, body, option);
  }

  static async delete(url) {
    return Axios.delete(url);
  }

  static async put(url, body) {
    return Axios.put(url, body);
  }
}
